/* G34: share the proven Golf/native modal bridge across product-card surfaces. */
(() => {
  if (window.__lcsG15QuickShopBridgeBound) return;
  window.__lcsG15QuickShopBridgeBound = true;
  const mediaLoads = new WeakMap();
  window.TZQuickShopMedia = {
    begin(modal) {
      mediaLoads.get(modal)?.cancel?.();
      const request = {};
      mediaLoads.set(modal, request);
      modal.classList.remove('tz-quick-media-error');
      modal.classList.add('tz-quick-media-pending');
      return request;
    },
    show(modal, image, source) {
      // Keep a decoded image only within the current presentation/colour context.
      const retain = !modal.classList.contains('tz-quick-media-pending') &&
        !image.hidden && image.complete && image.naturalWidth > 0;
      const request = this.begin(modal);
      if (retain) modal.classList.remove('tz-quick-media-pending');
      const pending = new Image();
      pending.decoding = 'async';
      pending.fetchPriority = 'high';
      const current = () => mediaLoads.get(modal) === request;
      const cleanup = () => { pending.onload = null; pending.onerror = null; };
      const reveal = () => {
        if (!current()) return;
        cleanup();
        image.src = source;
        image.hidden = false;
        modal.classList.remove('tz-quick-media-pending', 'tz-quick-media-error');
      };
      const failed = () => {
        if (!current()) return;
        cleanup();
        if (!retain) { image.hidden = true; modal.classList.add('tz-quick-media-error'); }
        modal.classList.remove('tz-quick-media-pending');
      };
      request.cancel = cleanup;
      pending.onload = () => {
        if (!current() || !pending.naturalWidth) return;
        if (typeof pending.decode === 'function') pending.decode().then(reveal, reveal);
        else reveal();
      };
      pending.onerror = failed;
      pending.src = source;
      if (pending.complete && pending.naturalWidth) pending.onload();
    }
  };
  const selector = '.quick-product__btn.lcs-g15-quick-shop';
  // Native hover and the first-click bridge can request the same product together.
  // Deduplicate at the common native entry point so a late response cannot wipe
  // an already opened form or replace its initialized gallery.
  const nativePreload = window.theme?.preloadProductModal;
  const nativeRequests = new WeakSet();
  if (typeof nativePreload === 'function') {
    window.theme.preloadProductModal = function(handle, id, button) {
      const holder = document.getElementById('QuickShopHolder-' + handle);
      if (!holder || holder.querySelector('.product-section') || nativeRequests.has(holder)) return;
      nativeRequests.add(holder);
      const release = new MutationObserver(() => {
        if (!holder.querySelector('.product-section')) return;
        release.disconnect();
        nativeRequests.delete(holder);
      });
      release.observe(holder, { childList: true });
      setTimeout(() => { release.disconnect(); nativeRequests.delete(holder); }, 10000);
      return nativePreload.call(this, handle, id, button);
    };
  }
  // G36: wait for the native lazy form, then use its color handler.
  // Native handlers own variant id, price, media, size and availability.
// Catalog cards use the existing Motion modal, variant form and cart pipeline.
const catalogModals = new WeakMap();
const syncCatalog = button => {
  const card = button.closest('.catalog-browse__card,[data-quick-context-card]');
  if (!card) return false;
  const { holder, link } = context(button);
  if (!holder || !link) return true;
  const modal = holder.closest('.modal');
  modal.toggleAttribute('data-alpine-native',card.dataset.alpineNative==='true');
  window.TZQuickShopMedia.begin(modal);
  modal.dataset.tzPresentation = card.dataset.context;
  const entry = new URL(link.href,location.href).searchParams.get('entry') || 'catalog';
  modal.dataset.tzEntry = entry;
  let state = catalogModals.get(holder);
  if (!state) { state = {}; catalogModals.set(holder,state); }
  state.colourKey = value => window.catalogColourKey(value,card.dataset.productId || card.dataset.id);
  state.card = card; state.index = 0; state.entry = entry;
  try { state.gallery=JSON.parse(card.querySelector('[data-catalog-gallery]')?.textContent || '{}'); } catch {state.gallery={};}
  state.variantId = new URL(link.href,location.href).searchParams.get('variant');
  state.observer?.disconnect(); clearTimeout(state.timer);
  const apply = () => {
    const section = holder.querySelector('.product-section');
    if (!section?.querySelector('.product-form-holder--loaded')) return false;
    const nativeReady94 = String(window.Shopify?.theme?.id)==='154095845572' && document.getElementById('wize-v2') && section.dataset.alpineNativeModal94==='true';
    let variants;
    try { variants=JSON.parse(section.querySelector('[data-variant-json]')?.value || '[]'); } catch { return false; }
    const variant=variants.find(v=>String(v.id)===state.variantId);
    if (!variant) return false;
    const nativeGallery94 = nativeReady94 && String(section.dataset.productId)==='8817047699652';
    if (!state.bound) {
      state.bound=true;
      const native=section.querySelector('.product__photos');
      if (native && !nativeGallery94) {
        const stage=document.createElement('div');stage.className='ev-quick-gallery catalog-quick-gallery tz-gallery-simple';
        const image=document.createElement('img');image.width=900;image.height=1350;image.alt='';
        const nav=document.createElement('div');nav.className='ev-quick-gallery__nav';
        const previous=document.createElement('button');previous.type='button';previous.setAttribute('aria-label',(document.documentElement.lang.startsWith('en') ? 'Previous product image' : '上一張商品照'));
        const next=document.createElement('button');next.type='button';next.setAttribute('aria-label',(document.documentElement.lang.startsWith('en') ? 'Next product image' : '下一張商品照'));
        const count=document.createElement('span');count.className='ev-quick-gallery__count';count.setAttribute('aria-live','polite');
        for(const [control,path] of [[previous,'M14 5 7 12l7 7'],[next,'m10 5 7 7-7 7']]){
          const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('aria-hidden','true');
          const line=document.createElementNS(svg.namespaceURI,'path');line.setAttribute('d',path);svg.append(line);control.append(svg);
        }
        const dots=document.createElement('div');dots.className='tz-quick-gallery-dots';dots.setAttribute('role','group');dots.setAttribute('aria-label','選擇商品照片');
        nav.append(previous,count,next);stage.append(image,nav,dots);native.before(stage);native.hidden=true;
        state.dots=dots;
        dots.addEventListener('click',event=>{const dot=event.target.closest('[data-gallery-index]');if(!dot)return;event.preventDefault();event.stopPropagation();const hadFocus=document.activeElement===dot;state.index=Number(dot.dataset.galleryIndex);state.render();if(hadFocus)state.dots.querySelector('[aria-current="true"]')?.focus({preventScroll:true});});
        Object.assign(state,{stage,image,count,nav});
        const move=delta=>{if(state.photos?.length){state.index=(state.index+delta+state.photos.length)%state.photos.length;state.render();}};
        previous.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
        // Preserve vertical page scrolling; commit only a clear horizontal swipe.
        let swipeStart=null;
        stage.style.touchAction='pan-y';
        stage.addEventListener('pointerdown',event=>{
          if(event.target.closest('button,video') || !event.isPrimary || event.button!==0)return;
          swipeStart={x:event.clientX,y:event.clientY,id:event.pointerId};
          stage.setPointerCapture(event.pointerId);
        });
        stage.addEventListener('pointerup',event=>{
          const start=swipeStart;swipeStart=null;
          if(!start || start.id!==event.pointerId)return;
          const dx=event.clientX-start.x,dy=event.clientY-start.y;
          if(Math.abs(dx)>48 && Math.abs(dx)>Math.abs(dy)*1.5)move(dx<0?1:-1);
        });
        stage.addEventListener('pointercancel',()=>{swipeStart=null;});
        image.draggable=false;
        document.addEventListener('modalClose.'+modal.id,()=>state.video?.pause());
      }
      state.render=()=>{
        if(!state.image||!state.photos?.length){if(nativeGallery94)modal.classList.remove('tz-quick-media-pending');return;}
        const media=state.photos[state.index];
        state.video?.pause();state.video?.remove();state.video=null;
        if(media.type==='video'){
          window.TZQuickShopMedia.begin(modal);
          const video=document.createElement('video');video.controls=true;video.playsInline=true;video.muted=true;video.defaultMuted=true;video.autoplay=true;video.loop=true;video.preload='metadata';video.poster=media.poster;video.src=media.sources[0].src;video.setAttribute('aria-label','商品實拍影片');
          state.image.hidden=true;state.stage.prepend(video);state.video=video;modal.classList.remove('tz-quick-media-pending');window.AlpineNative.observeVideo(video);video.play().catch(()=>{/* Native controls remain available if autoplay is restricted. */});
        }else {
          let src=media.src;
          try {
            const url=new URL(src,location.href);
            if(url.hostname==='cdn.shopify.com' || (url.origin===location.origin && url.pathname.startsWith('/cdn/shop/'))){
              const width=Math.min(1600,Math.ceil((state.stage.clientWidth || 600)*Math.min(window.devicePixelRatio || 1,2)/100)*100);
              url.searchParams.set('width',String(width));src=url.href;
            }
          }catch(_){}
          window.TZQuickShopMedia.show(modal,state.image,src);
        }state.image.alt=state.card.querySelector('h2,.lh-card__title')?.textContent || '';
        state.count.textContent=(state.index+1)+' / '+state.photos.length;state.nav.hidden=state.photos.length<2;
        if(state.dots){
          state.dots.hidden=state.photos.length<2;
          // Keep every photo reachable without an overflowing row of 24+ dots.
          const length=state.photos.length,start=Math.max(0,Math.min(state.index-3,length-7)),end=Math.min(length,start+7);
          state.dots.replaceChildren(...Array.from({length:end-start},(_,offset)=>{
            const i=start+offset,button=document.createElement('button');button.type='button';button.dataset.galleryIndex=String(i);
            button.setAttribute('aria-label','第 '+(i+1)+' 張，共 '+length+' 張');button.setAttribute('aria-current',String(i===state.index));
            if((i===start&&start>0)||(i===end-1&&end<length))button.classList.add('is-edge');
            return button;
          }));
        }
      };
      state.update=v=>{
        state.currentVariant=v;
        state.video?.pause();
        const ctx=state.card.dataset.context;
        const form=section.querySelector('form[action*="/cart/add"]');
        const color=v.options?.find(value=>state.gallery.contexts?.[ctx]?.[state.colourKey(value)]) || state.card.querySelector('[aria-pressed="true"]')?.getAttribute('data-native-colour') || state.card.querySelector('[aria-pressed="true"]')?.getAttribute('data-r52-colour') || state.card.querySelector('[aria-pressed="true"]')?.getAttribute('data-card-swatch') || (nativeGallery94?[...section.querySelectorAll('[data-variant-input]:checked')].find(input=>/^(color|colour|顏色|外套顏色)$/i.test(input.name))?.value:'') || '';
        if(form)for(const [key,value] of Object.entries({_tz_presentation:ctx,_tz_entry:state.entry,_tz_colour:color,_tz_context_version:'1'})){
          let input=form.querySelector('[name="properties['+key+']"]');
          if(!input){input=document.createElement('input');input.type='hidden';input.name='properties['+key+']';form.append(input);}input.defaultValue=value;input.value=value;
        }
        const colors=state.gallery.contexts?.[ctx] || state.gallery.contexts?.neutral || state.gallery.colours || {};
        let photos=v.options?.map(color=>colors[state.colourKey(color)]).find(Boolean);
        if(!photos){
          const data=state.card.querySelector('[data-r52-data]');
          let gallery;
          if(data){try{const d=JSON.parse(data.textContent);gallery=d.galleries[state.colourKey(v.options[d.colourIndex])];}catch{}}
          const swatch=[...state.card.querySelectorAll('[data-native-colour]')].find(s=>v.options.includes(s.dataset.nativeColour));
          photos=[gallery?.cover||swatch?.dataset.cover||state.card.querySelector('[data-native-cover],[data-r52-cover],.lh-card__cover')?.src,gallery?.secondary||swatch?.dataset.secondary].filter(Boolean).map(src=>({src,type:'image'}));
        }
        // A different gallery must never retain the previous colour or model.
        const galleryKey = ctx + '|' + color;
        if (state.mediaContext !== galleryKey) {
          window.TZQuickShopMedia.begin(modal);
          state.mediaContext = galleryKey;
        }
        state.photos=state.card.dataset.alpineNative==='true' ? window.AlpineNative.media(photos,{id:state.card.dataset.productId},ctx,color) : photos.filter(p=>p.type==='image');state.index=0;state.render();
      };
      section.addEventListener('variantChange',e=>{if(e.detail?.variant)state.update(e.detail.variant);});
      section.querySelector('form[action*="/cart/add"]')?.addEventListener('submit',()=>{if(state.currentVariant)state.update(state.currentVariant);},true);
    }
    const controls=variant.options.map((value,i)=>[...section.querySelectorAll('[data-variant-input]')].find(input=>input.dataset.index==='option'+(i+1)&&(input.value===value||(input.tagName==='SELECT'&&[...input.options].some(o=>o.value===value)))));
    if(controls.some(c=>!c))return false;
    if(nativeReady94){
      // Motion tracks the last changed option internally; notify each real control.
      controls.forEach((input,i)=>{if(input.type==='radio'||input.type==='checkbox')input.checked=true;else input.value=variant.options[i];input.dispatchEvent(new Event('change',{bubbles:true}));});
    }else{
      controls.forEach((input,i)=>{if(input.type==='radio'||input.type==='checkbox')input.checked=true;else input.value=variant.options[i];});
      controls.at(-1)?.dispatchEvent(new Event('change',{bubbles:true}));
    }
    state.update(variant);
    window.AlpinePurchaseOptions?.init?.();
    holder.querySelectorAll('a[href*="/products/"]').forEach(a=>{const url=new URL(a.href,location.href);url.searchParams.set('presentation',card.dataset.context);a.href=url.href;});
    state.observer?.disconnect();clearTimeout(state.timer);return true;
  };
  if(!apply()){
    // Motion marks its existing form loaded by changing a class after insertion.
    state.observer=new MutationObserver(apply);state.observer.observe(holder,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
    state.timer=setTimeout(()=>state.observer?.disconnect(),10000);
  }
  return true;
};

  const colorSync = new WeakMap();
  const mediaBindings = new WeakMap();
  const imageKey = source => {
    try { return decodeURIComponent(new URL(source, location.href).pathname.split('/').pop()).replace(/_\d+x\d*(?=\.)/, ''); }
    catch (_) { return ''; }
  };
  const bindCardMedia = (holder, button) => {
    const section = holder.querySelector('.product-section');
    if (!section) return;
    const existing = mediaBindings.get(section);
    if (existing) { existing.button = button; return; }
    const state = { button };
    mediaBindings.set(section, state);
    section.addEventListener('variantChange', event => {
      const variant = event.detail?.variant;
      if (!variant || variant.featured_image) return;
      const card = state.button.closest('.grid-product,.catalog-browse__card,[data-quick-context-card]');
      const swatch = Array.from(card?.querySelectorAll('[data-ss26-card-swatch]') || []).find(item => {
        const index = Number(item.dataset.ss26SwatchOption?.replace('option', '')) - 1;
        return variant.options?.[index] === item.dataset.ss26SwatchColor;
      });
      const key = imageKey(swatch?.dataset.ss26SwatchImage);
      if (!key) return;
      // The native gallery event also works when mobile thumbnails are hidden.
      const thumb = Array.from(section.querySelectorAll('[data-product-thumb]')).find(link =>
        imageKey(link.querySelector('img')?.getAttribute('src')) === key || imageKey(link.href) === key
      );
      if (thumb) section.dispatchEvent(new CustomEvent('variantImageChange', {
        detail: { variant: { ...variant, featured_media: { id: thumb.dataset.id, preview_image: { src: thumb.href } } } }
      }));
    });
  };
  const syncCardColor = (button) => {
    if(syncCatalog(button))return;
    const { holder } = context(button);
    const swatch = button.closest('.grid-product,.catalog-browse__card,[data-quick-context-card]')?.querySelector('[data-ss26-card-swatch].is-active');
    const color = swatch?.dataset.ss26SwatchColor;
    if (!holder || !color) return;
    colorSync.get(holder)?.();
    bindCardMedia(holder, button);
    let observer, timer;
    const finish = () => {
      observer?.disconnect();
      clearTimeout(timer);
      colorSync.delete(holder);
    };
    const apply = () => {
      if (!holder.querySelector('.product-form-holder--loaded')) return false;
      const index = swatch.dataset.ss26SwatchOption;
      const input = Array.from(holder.querySelectorAll('[data-variant-input]')).find(el =>
        (!index || el.dataset.index === index) &&
        (el.value === color || (el.tagName === 'SELECT' && Array.from(el.options).some(o => o.value === color)))
      );
      if (input) {
        if (input.type === 'radio' || input.type === 'checkbox') input.checked = true;
        else input.value = color;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      finish();
      return true;
    };
    observer = new MutationObserver(apply);
    colorSync.set(holder, finish);
    observer.observe(holder, { childList: true, subtree: true });
    timer = setTimeout(finish, 10000);
    apply();
  };

  const loading = new WeakMap();
  const observedMedia = new WeakSet();
  const context = button => {
    const card = button.closest('.grid-product,.catalog-browse__card,[data-quick-context-card]');
    const handle = card?.dataset.productHandle;
    const holder = handle ? document.getElementById('QuickShopHolder-' + handle) : null;
    const modal = holder?.closest('.modal');
    // A native hotspot can own this same modal inside a hidden slide.
    // Keep one modal instance and preserve its listeners outside hidden ancestors.
    if (card?.matches('.catalog-browse__card,[data-quick-context-card]') && modal && modal.parentElement !== document.body) {
      document.body.append(modal);
    }
    return {
      id: card?.dataset.productId,
      handle,
      holder,
      link: card?.querySelector('.grid-product__link,[data-native-link],[data-r52-link],[data-card-link]')
    };
  };
  const modalStates = new Map();
  const rememberModalTrigger = button => {
    const { id } = context(button);
    if (!id) return;
    const modalId = 'QuickShopModal-' + id;
    let state = modalStates.get(modalId);
    if (!state) {
      state = { trigger: null, timer: null };
      modalStates.set(modalId, state);
      const setExpanded = open => {
        document.querySelectorAll(selector).forEach(item => {
          if (item.getAttribute('aria-controls') === modalId) {
            item.setAttribute('aria-expanded', String(open && item === state.trigger));
          }
        });
      };
      document.addEventListener('modalOpen.' + modalId, () => {
        clearTimeout(state.timer);
        const modal = document.getElementById(modalId);
        if (!modal) return;
        modal.setAttribute('aria-hidden', 'false');
        setExpanded(true);
      });
      document.addEventListener('modalClose.' + modalId, () => {
        clearTimeout(state.timer);
        const modal = document.getElementById(modalId);
        const trigger = state.trigger;
        modal?.setAttribute('aria-hidden', 'true');
        setExpanded(false);
        state.timer = setTimeout(() => {
          if (!trigger?.isConnected || trigger.disabled || !trigger.getClientRects().length) return;
          if (document.querySelector('.modal--is-active, .drawer--is-open')) return;
          const active = document.activeElement;
          if (active !== document.body && active !== document.documentElement && !modal?.contains(active)) return;
          trigger.focus({ preventScroll: true });
        }, 510);
      });
    }
    state.trigger = button;
  };
  const fallback = button => {
    button.removeAttribute('aria-busy');
    {
      let notice = button.parentElement.querySelector('[data-quick-shop-retry]');
      if (!notice) {
        notice = document.createElement('p');
        notice.dataset.quickShopRetry = '';
        notice.setAttribute('role', 'status');
        button.parentElement.append(notice);
      }
      notice.textContent = '載入較慢，請再點一次＋。';
      return;
    }
    // Keep failed Quick Shop attempts on the originating page.
  };
  const preload = (button, shouldOpen = false) => {
    const { id, handle, holder } = context(button);
    if (!id || !handle || !holder || typeof window.theme?.preloadProductModal !== 'function') {
      if (shouldOpen) fallback(button);
      return;
    }
    if (holder.querySelector('.product-section')) return;
    let pending = loading.get(holder);
    if (pending) {
      if (shouldOpen) pending.button = button;
      return;
    }
    pending = { button: shouldOpen ? button : null };
    button.parentElement.querySelector('[data-quick-shop-retry]')?.remove();
    loading.set(holder, pending);
    button.setAttribute('aria-busy', 'true');
    const finish = success => {
      observer.disconnect();
      clearTimeout(timeout);
      loading.delete(holder);
      button.removeAttribute('aria-busy');
      if (!pending.button) return;
      const trigger = pending.button;
      pending.button = null;
      if (success && trigger.isConnected) {
        // Native preload registers its modal before this observer callback.
        setTimeout(() => trigger.click(), 0);
      } else if (!success) fallback(trigger);
    };
    const observer = new MutationObserver(() => {
      if (holder.querySelector('.product-section')) finish(true);
    });
    observer.observe(holder, { childList: true });
    const timeout = setTimeout(() => finish(Boolean(holder.querySelector('.product-section'))), 10000);
    try {
      window.theme.preloadProductModal(handle, id, button);
    } catch (_) {
      finish(false);
    }
  };
  // Warm only Alpine cards that enter the viewport, capped per page visit.
  // Reuse the native modal cache; never fetch every product at page load.
  const warmObserved = new WeakSet(), warmIds = new Set();
  const warmObserver = document.querySelector('#wize-v2') && typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting || warmIds.size >= 6) return;
      const button = entry.target, id = context(button).id;
      if (!id || warmIds.has(id)) return;
      warmIds.add(id);
      warmObserver.unobserve(button);
      preload(button);
    });
  }, {threshold: 0.5}) : null;
  let frame = 0;
  const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(() => schedule()) : null;
  const position = () => {
    frame = 0;
    document.querySelectorAll(selector).forEach(button => {
      if (warmObserver && !warmObserved.has(button)) {
        warmObserved.add(button); warmObserver.observe(button);
      }
      const media = button.closest('.grid-product__content,.catalog-browse__card,[data-quick-context-card]')?.querySelector('.grid-product__image-mask,.catalog-browse__photo,.lh-card__photo');
      if (!media) return;
      if (resizeObserver && !observedMedia.has(media)) {
        resizeObserver.observe(media);
        observedMedia.add(media);
      }
      if (!media.offsetHeight) return;
      const inset = matchMedia('(max-width: 749px)').matches ? 7 : 8;
      const top = Math.max(inset, media.offsetTop + media.offsetHeight - button.offsetHeight - inset) + 'px';
      if (button.style.getPropertyValue('--lcs-g15-quick-shop-top') !== top) {
        button.style.setProperty('--lcs-g15-quick-shop-top', top);
      }
    });
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(position);
  };
  const scope = document.getElementById('MainContent') || document.body;
  new MutationObserver(records => {
    if (records.some(record => record.addedNodes.length || record.removedNodes.length)) schedule();
  }).observe(scope, { childList: true, subtree: true });
  addEventListener('resize', schedule, { passive: true });
  document.addEventListener('load', schedule, true);
  document.addEventListener('shopify:section:load', schedule);
  schedule();
  for (const eventName of ['pointerover', 'pointerdown', 'focusin']) {
    document.addEventListener(eventName, event => {
      const button = event.target.closest?.(selector);
      if (button) preload(button);
    }, true);
  }
  document.addEventListener('click', event => {
    const button = event.target.closest?.(selector);
    if (!button) return;
    rememberModalTrigger(button);
    const { holder } = context(button);
    if (holder?.querySelector('.product-section')) {
      syncCardColor(button);
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    preload(button, true);
  }, true);
})();
